// src/components/productDetail/VideoBlock.tsx
import React from 'react';
import './VideoBlock.css';

interface VideoBlockProps {
    url: string;
    title?: string;
    description?: string;
}

export const VideoBlock: React.FC<VideoBlockProps> = ({
    url,
    title,
    description
}) => {
    // Extrair ID do YouTube
    const getYouTubeId = (url: string): string | null => {
        const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    const videoId = getYouTubeId(url);

    if (!videoId) {
        return (
            <div className="prdth-video-block">
                <div className="prdth-video-error">
                    <p>URL de vídeo inválida</p>
                </div>
            </div>
        );
    }

    return (
        <div className="prdth-video-block">
            {title && <h3 className="prdth-video-title">{title}</h3>}

            <div className="prdth-video-wrapper">
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={title || 'Vídeo do produto'}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="prdth-video-iframe"
                />
            </div>

            {description && (
                <p className="prdth-video-description">{description}</p>
            )}
        </div>
    );
};